var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:{
    'alert':		true,
    'alert-success':(_vm.type == 'success'),
    'alert-warning':(_vm.type == 'warning'),
    'alert-info':	(_vm.type == 'info'),
    'alert-danger':	(_vm.type == 'danger'),
    'top': 			(_vm.placement === 'top'),
    'top-right': 	(_vm.placement === 'top-right')
  },style:({width:_vm.width}),attrs:{"transition":"fade","role":"alert"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.dismissable),expression:"dismissable"}],staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.closeAlert}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-168e62ab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/especiais/libs/AlertLib.vue
// module id = jGiz
// module chunks = 49